<template>
  <div class="Popup">
    <button @click="modalClose" class="close-button">
      <img
        class="close-icon"
        src="../../../assets/homePage/X.svg"
        alt="An 'X' icon for closing the popup"
      />
    </button>
    <div class="Container">
      <div class="text-content">
        <div class="title" v-html="$t('locations_popup.title')"></div>
        <div
          v-html="$t('locations_popup.text')"
          class="flex flex-col space-y-4 text-qwraylight mt-6"
        ></div>
        <img
          class=" md:invisible mt-5 block mx-auto"
          width="136"
          src="../../../assets/netherlands/parkLogo.webp"
          alt="Icons of German cities on a Map of Germany"
        />
        <div class="mt-5 text-qwraylight">
          {{ $t('homepage.cta_question') }}
        </div>
        <a
          href="https://www.parkncharge.nl/laden-in-je-buurt/openbare-laadpaal-aanvragen/?_gl=1*1qcdwym*_up*MQ..&gclid=CjwKCAjwmaO4BhAhEiwA5p4YL9y2r364Dw0bJExPXrjEVkkHh1kSm-TENxmK3Rw8pjvWWGPvK_MvkhoCTFsQAvD_BwE"
          target="_blank"
          class="ExternalFormCTA mt-5"
        >
          <div
            class="PilotText px-5 py-2 text-sm tracking-0.24px md:tracking-0.4px text-center md:mt-2"
          >
            {{ $t('locations_popup.btn') }}
          </div>
        </a>
      </div>
      <div class="MapContainer">
        <img
          class="parkLogo"
          src="../../../assets/netherlands/parkLogo.webp"
          alt="Icons of German cities on a Map of Germany"
        />
        <img
          class="parkPole"
          src="../../../assets/netherlands/parkPole.webp"
          alt="Icons of German cities on a Map of Germany"
        />
      </div>
    </div>
  </div>
</template>

<script>
import locations from '@/data/locations.json';

export default {
  name: 'PopupNL',
  data() {
    return { locations };
  },
  methods: {
    modalClose() {
      this.$emit('modalClose');
    },
  },
};
</script>

<style scoped>
.Popup {
  z-index: 100;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  max-width: var(--max-width);
  width: var(--popup-width);
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 21px;
  display: flex;
  flex-direction: column;
  --padding-horizontal: 22px;
  --padding-vertical: 40px;
  --title-f-size: 30px;
  --text-f-size: 14px;
  --max-width: 400px;
  --popup-width: 90vw;
  --max-height: auto;
  --text-margin-top: 32px;
  --location-margin-bottom: 0px;
  --contact-f-size: 14px;
  --sub-f-size: 14px;
  --locations-primary-text-color: #41565d;
  --locations-popup-grid-columns: 1fr;
  --locations-popup-loc-padding: 5px 0;
  --locations-popup-grid-rows: 1fr 1fr;
  --map-container-column: 1;
  --title-max-width: 100%;
  --locations-popup-container-grid: block;
  --contact-icon-width: 20px;
  --text-end-template-rows: 0.7fr 1fr;
  --text-end-margin-top: 20px;
  --popup-title-text-indent: 20px;
  --title-padding: 0 20px;
  padding-bottom: var(--padding-vertical);
}
.Container {
  display: var(--locations-popup-container-grid);
  grid-template-columns: var(--locations-popup-grid-columns);
  grid-template-rows: var(--locations-popup-grid-rows);
}
.close-button {
  justify-self: flex-end;
  align-self: flex-end;
  margin: 14px;
}
.close-icon {
  width: 21px;
  height: 21px;
}
.title {
  font-size: var(--title-f-size);
  line-height: 36px;
  max-width: var(--title-max-width);
  color: #2b4047;
  letter-spacing: 0;
  font-family: 'Foco';
  width: 75%;
}
.text-content {
  padding: 0 20px;
  font-size: var(--text-f-size);
}
.text-end {
  display: grid;
  padding-left: var(--padding-horizontal);
  padding-right: var(--padding-horizontal);
  font-size: var(--text-f-size);
  grid-template-columns: 1fr 1fr;
}
.contact {
  display: flex;
  padding-left: var(--padding-horizontal);
  flex-direction: column;
}
.contact-item {
  color: #5e7177;
  font-size: var(--contact-f-size);
  font-weight: normal;
  font-family: 'Lato';
  display: flex;
  align-items: center;
}
.icon {
  margin-right: 8px;
}
.marginRight {
  margin-right: 35px;
}
.locations {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.locations div {
  width: 100%;
}

.location {
  display: flex;
  padding: var(--locations-popup-loc-padding);
  align-items: center;
  margin-bottom: var(--location-margin-bottom);
}
.subtitle-text {
  font-size: var(--sub-f-size);
  margin-bottom: var(--location-margin-bottom);
  color: var(--locations-primary-text-color);
  font-family: 'Lato';
  height: min-content;
  align-self: center;
  grid-row: 1;
  grid-column: 1;
}
.location-text {
  margin-left: 20px;
  font-size: var(--sub-f-size);
  color: var(--locations-primary-text-color);
  font-family: 'Lato';
}
.icon {
  width: var(--contact-icon-width);
  height: var(--contact-icon-width);
}
.MapContainer {
  margin: 0 auto;
  display: none;
}
.DesktopMap {
}
.MobileMap {
  align-self: flex-end;
  width: 100%;
}
.text-end {
}
@media (min-width: 768px) {
  .Popup {
    --padding-horizontal: 37px;
    --padding-vertical: 37px;
    --max-width: 1200px;
    --popup-width: 80%;
    --max-height: 760px;
    --title-f-size: 30px;
    --title-f-line-height: 40px;
    --text-margin-top: 80px;
    --location-margin-bottom: 20px;
    --locations-popup-grid-columns: 1fr 0.8fr;
    --locations-popup-grid-rows: 1fr;
    --map-container-column: 2;
    --locations-popup-container-grid: grid;
    --locations-popup-loc-padding: 10px 0;
    --contact-f-size: 16px;
    --contact-icon-width: auto;
    --sub-f-size: 16px;
    --text-end-margin-top: 0px;
    --title-padding: 0px;
    --popup-title-text-indent: 0;
  }
  .MapContainer {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }
  .title {
    width: 100%;
    line-height: 64px;
  }
  .text-end {
    display: block;
  }
  .MobileMap {
    display: none;
  }
  .contact {
    flex-direction: row;
  }
  .text-content {
    padding-left: var(--padding-horizontal);
  }
  .text-end {
    padding-left: 0;
  }
  .close-button {
    margin: 20px;
  }
  .close-icon {
    width: 25px;
    height: 25px;
  }
  .subtitle-text {
    margin-top: var(--text-margin-top);
  }
  .locations div {
    width: 50%;
  }
}
@media (min-width: 1200px) {
  .Popup {
    --locations-popup-grid-columns: 1.4fr 1fr;
    --title-f-size: 50px;
    --popup-width: 100%;
    --padding-horizontal: 82px;
    --padding-vertical: 90px;
    --sub-f-size: 20px;
    --contact-f-size: 20px;
    --title-f-line-height: 70px;
    --title-f-max-width: 22ch;
  }
}
</style>

<style>
.YellowHighlight {
  background-color: #ffdf22;
  padding: 5px;
  border-color: #ffdf22;
  width: max-content;
}

.parkLogo {
  width: 179px;
  float: right;
}
.parkPole {
  width: 313px;
  height: 321px;
  float: right;
  margin-top: 2rem;
}

.ExternalFormCTA {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--qwellow);
  color: var(--qwray);
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #ffdf22;
  width: fit-content;
  border-radius: 99px;
  margin-left: auto;
  margin-right: auto;
}
.ExternalFormCTA[margin] {
  margin-bottom: 4em;
}
@media (min-width: 768px) {
  .ExternalFormCTA {
    font: normal normal bold 24px/28px Lato;
    letter-spacing: 0.48px;
    border-radius: 40px;
    /* padding: 1em 1.8em; */
    width: max-content;
    margin-left: 0;
  }
  .ExternalFormCTA[margin] {
    margin-bottom: unset;
  }
}
.PilotText {
  font-size: 16px;
  margin-top: 0;
}
</style>
